import React from 'react';
import { FileTextIcon, GiftIcon } from 'lucide-react';
import type { Bonus } from '../data/bonuses';
export function BonusCard({
  bonus
}: {
  bonus: Bonus;
}) {
  return <article className="overflow-hidden rounded-2xl shadow-lg shadow-black/30" data-id="element-18" data-mp="2o5v6a6qvvyl2">
      <div className="flex items-center gap-3 bg-blue-700 px-4 py-3 md:px-5" data-id="element-19" data-mp="2t10td8w0vjaq">
        <span className="inline-flex shrink-0 items-center gap-1.5 rounded-md bg-yellow-300 px-2.5 py-1 text-[10px] font-black uppercase tracking-wider text-blue-950 md:text-[11px]" data-id="element-20" data-mp="2x46wi7nu8ucz">
          <GiftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-21" data-mp="25elx5yl0zbu0" />
          Free Bonus {bonus.number}
        </span>
        <h3 className="text-sm font-black uppercase leading-tight text-white md:text-base" data-id="element-22" data-mp="29dl0xfv0t2jv">{bonus.name}</h3>
      </div>
      <div className="bg-white px-4 py-4 md:px-5" data-id="element-23" data-mp="2e7yzts8w5rta">
        <p className="text-sm font-semibold leading-relaxed text-blue-950" data-id="element-24" data-mp="1horlvlgctvbv">{bonus.summary}</p>
        <p className="mt-2 text-sm leading-relaxed text-slate-600" data-id="element-25" data-mp="1lp1uz6zg11uy">{bonus.includes}</p>
        <p className="mt-2 text-sm italic leading-relaxed text-blue-700" data-id="element-26" data-mp="1x1v6mt8rlgwh">{bonus.idealFor}</p>
        <p className="mt-3 flex items-center gap-1.5 text-xs font-black uppercase tracking-wide text-blue-950" data-id="element-27" data-mp="1s3a58qhs0r6g">
          <FileTextIcon className="h-4 w-4 text-blue-700" aria-hidden="true" data-id="element-28" data-mp="1nbs2bww70giu" />
          {bonus.pages}
        </p>
        <div className="mt-4 flex items-center justify-end gap-3 border-t border-blue-950/10 pt-3" data-id="element-29" data-mp="1ic74xqwo8g88">
          <span className="text-sm font-black text-slate-600 line-through decoration-red-600 decoration-2" data-id="element-30" data-mp="1df6xpco357fj">
            ${bonus.value} USD
          </span>
          <span className="rounded-md bg-blue-950 px-3 py-1 text-xs font-black uppercase text-yellow-300" data-id="element-31" data-mp="19ewq5vkna8yk">Free</span>
        </div>
      </div>
    </article>;
}